// src/components/Pages/HelpPage.tsx
import React from 'react';

export const HelpPage: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Help & Documentation</h1>
      
      <section className="help-section">
        <h2>Getting Started</h2>
        <div className="help-content">
          <h3>1. Data Upload</h3>
          <p>Upload your CSV file containing X, Y, Z coordinates or Lat/Long data.</p>
          
          <h3>2. Grid Configuration</h3>
          <p>Choose your desired grid resolution and review the preview.</p>
          
          <h3>3. Interpolation</h3>
          <p>Select an interpolation method and adjust parameters as needed.</p>
          
          <h3>4. Visualization</h3>
          <p>Customize your contour plot with various styling options.</p>
          
          <h3>5. Export</h3>
          <p>Export your results in your preferred format.</p>
        </div>
      </section>
      
      <section className="help-section">
        <h2>FAQs</h2>
        <div className="faq-list">
          {/* Add FAQs here */}
        </div>
      </section>
    </div>
  );
};